import { type ChangeEvent, type MouseEvent, useState } from 'react';
import { Link, useNavigate } from 'react-router';
import Config, { type MultiLang } from '../config';
import ItemUtil from '../database/lib/ItemUtil';
import Functions from '../functions';
import imageJapanNode from './assets/theme/images/icon_jnode.png';
import LinkImage from './lib/LinkImage';

interface Props {
    lang: MultiLang;
}

const Header = (props: Props) => {
    const { lang } = props;
    const navigate = useNavigate();
    const [keyword, setKeyword] = useState('');

    const handleChangeKeyword = (event: ChangeEvent<HTMLInputElement>) => {
        setKeyword(event.target.value);
    };

    const handleSubmit = (event: MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        if (keyword.trim() !== '') {
            void navigate(ItemUtil.getSearchByKeywordUrl('all', keyword));
        }
    };

    const title = Functions.mlang(Config.SITE_TITLE, lang);
    return (
        <div id="header" className="clearfix">
            <div className="left logo">
                <Link to="/">
                    <span className="hidden">{title}</span>
                </Link>
            </div>
            <div className="right">
                <input className="searchInput" type="text" value={keyword} onChange={handleChangeKeyword} />
                <button type="button" className="searchButton" onClick={handleSubmit}>
                    Search
                </button>
                <LinkImage image={imageJapanNode} title="INCF Japan Node" url={'https://www.neuroinf.jp/'} />
            </div>
        </div>
    );
};

export default Header;
